$(document).ready(function(){
   $(document).on("change","#shield-check",function(){
      if($(this).prop("checked")){
        $(".add_to_cart.ajax-submit").attr("data-shield-product","yes");
      }else{
        $(".add_to_cart.ajax-submit").attr("data-shield-product","no");
      }
   });

   $(document).on("change","#quantity",function(){
      const currentValue = $(this).val();
      const variantPrice = $(this).parents("form").find(".main_select").find(":selected").data("price");
      const shieldPrice =  (variantPrice*currentValue*20)/100;
      const finalPrice = parseFloat(shieldPrice/100).toFixed(2);
      $(".shield--price").html(window.Shopify.formatMoney(finalPrice, $('body').data('money-format')));
   });
});